import {take, put, select} from 'redux-saga/effects';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';
import {requestServiceCaseLock, resetServiceCaseLockTime} from '../../service-cases/sagas/serviceCaseLockRequests';

/**
 * Update ServiceAssignment power of attorney
 */
const updateServiceAssignmentPowerOfAttorney = function* updateServiceAssignmentPowerOfAttorney(params) {
    const {caller, assignmentType, serviceAssignmentLineNo, serviceCaseId,
        serviceAssignmentPowerOfAttorneyData} = params;

    const {serviceManager} = yield select(state => state.application);
    const ecsFlowService = serviceManager.loadService('ecsFlowService');
    const serviceCase = yield select(state => state.serviceCases.serviceCases[serviceCaseId]);

    if (!serviceCase) return;

    const lockUUID = serviceCase.lock ? serviceCase.lock.lockUUID : null;

    const lockResponse = yield* requestServiceCaseLock(ecsFlowService, serviceCaseId, {
        caller,
        lockUUID,
        lockContext: params.lockContext,
    });

    // if case is not locked or case is lockedBy current user -> allow patch
    if (!lockResponse.error && lockResponse.type === serviceCaseActionTypes.LOCK_SERVICE_CASE_REQUEST_SUCCEEDED) {
        yield* resetServiceCaseLockTime(serviceCaseId, params.lockContext);

        yield put({
            type: serviceAssignmentActionTypes.BATCH_UPDATE_SERVICE_ASSIGNMENT,
            payload: {
                assignmentType,
                serviceAssignmentLineNo,
                serviceCaseId,
                serviceAssignmentPowerOfAttorneyData,
                isPowerOfAttorneyUpdate: true,
            },
            meta: {caller},
        });

        let batchUpdateServiceAssignmentResponse;
        while (true) {
            const batchUpdateServiceAssignmentAction = yield take(
                serviceAssignmentActionTypes.BATCH_UPDATE_SERVICE_ASSIGNMENT_COMPLETED,
            );
            const {meta = {}} = batchUpdateServiceAssignmentAction;
            if (typeof meta.caller !== 'undefined' && meta.caller !== caller) continue;

            batchUpdateServiceAssignmentResponse = batchUpdateServiceAssignmentAction;
            break;
        }

        return batchUpdateServiceAssignmentResponse;
    }

    return lockResponse;
};

export default updateServiceAssignmentPowerOfAttorney;
